module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldCond.4049700.woff";